import { notification } from 'antd';
import { SRV2 } from '../api/pushGenie';
import { RESTRICTIONS } from '../restrictions/staffRestrictions';
import { getMe, getRoles } from './idbHandler';
import { createAclStyleSheet, deleteAclStyleSheet } from '../restrictions/utils';
import { track } from '../tracking';

class AccessControl {
    restrictionsApplied: { routes: Set<string>; actions: Set<string>; views: Set<string> } = {
        routes: new Set(),
        actions: new Set(),
        views: new Set(),
    };
    allRestrictions = new Map<
        SRV2,
        { routes: Set<string>; actions: Set<string>; views: Set<string> }
    >();

    constructor(data: SRV2[] = []) {
        RESTRICTIONS.forEach((restriction) => {
            this.allRestrictions.set(restriction.key, restriction);
        });

        data.forEach((appliedRestrictionKey) => {
            const routes = this.allRestrictions.get(appliedRestrictionKey)?.routes;
            this.restrictionsApplied.routes = new Set([
                ...this.restrictionsApplied.routes,
                ...(routes || []),
            ]);

            const actions = this.allRestrictions.get(appliedRestrictionKey)?.actions;
            this.restrictionsApplied.actions = new Set([
                ...this.restrictionsApplied.actions,
                ...(actions || []),
            ]);

            const views = this.allRestrictions.get(appliedRestrictionKey)?.views;
            this.restrictionsApplied.views = new Set([
                ...this.restrictionsApplied.views,
                ...(views || []),
            ]);
        });

        deleteAclStyleSheet();
        const restrictedViewsArray = Array.from(this.restrictionsApplied.views);
        createAclStyleSheet(restrictedViewsArray);
    }

    canAccessRoute(match: string): boolean {
        return !this.restrictionsApplied.routes.has(match);
    }

    isAllowed(action: string): boolean {
        return !this.restrictionsApplied.actions.has(action);
    }

    isAccessAvailable(name: string): boolean {
        return !this.restrictionsApplied.views.has(name);
    }
}

let accessControl: AccessControl = new AccessControl();

export const initAccessControl = async (trackingId: string): Promise<AccessControl | undefined> => {
    const me = getMe();
    if (!me) {
        // old azhar
        console.error('My profile is not available');
        return;
    }
    const myId = me.user.oid;
    const myRoles = me.roles || [];
    const data = await getRoles(myId, myRoles);
    if (myId && data) {
        const set: Set<SRV2> = new Set();
        data.forEach((i) => {
            const { policies } = i;
            const denyPolicies = policies.filter((i) => i.action === 'deny');
            denyPolicies.forEach((i) => set.add(i.subject as SRV2));
        });
        const array = Array.from(set);
        track('INIT_ACCESS_CONTROL', { trackingId, restrictions: array.join(', ') });
        accessControl = new AccessControl(array);
        return accessControl;
    }
    // captureErrorString('Error init access control');
};

export const getAccessControl = (): AccessControl => {
    return accessControl;
};

export function showAccessDeniedError() {
    notification.error({
        message: 'Access Denied',
        description: 'You do not have access to perform this action',
        duration: 5,
    });
}
